import React from 'react';
import { whatsappLink } from '../data/mock';

export default function FinalCTA() {
  return (
    <section className="py-24 lg:py-32 border-t border-[color:var(--gold-500)]/10">
      <div className="max-w-4xl mx-auto px-6 md:px-10 text-center">
        <p className="text-[11px] tracking-widest-2 text-[color:var(--gold-400)] uppercase mb-6">
          Pronto para começar?
        </p>
        <h2 className="font-serif text-4xl md:text-5xl lg:text-[3.5rem] leading-tight text-[color:var(--cream-100)]">
          Transforme sua{' '}
          <span className="italic text-[color:var(--gold-400)]">presença digital</span>{' '}
          hoje.
        </h2>
        <p className="mt-8 text-lg text-[color:var(--cream-100)]/75 max-w-2xl mx-auto">
          Cada projeto é único. Entre em contato e vamos entender juntos o melhor
          caminho para o seu negócio.
        </p>
        <a
          href={whatsappLink}
          target="_blank"
          rel="noopener noreferrer"
          className="mt-10 inline-flex items-center px-10 py-4 rounded-full bg-[color:var(--cream-100)] text-[color:var(--brown-900)] text-[11px] tracking-widest-2 uppercase font-medium hover:bg-white transition-colors"
        >
          Falar com a Ana no WhatsApp
        </a>
      </div>
    </section>
  );
}
